import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    shouldStartProview: false,
    shouldStopProview: false,
    getSessionUUID: '',
    sessionInitStatus: 'pending',
    isProviewReady: false,
    isSessionActive: false,
    isProviewV8Failed: false,
};
export const proviewSlice = createSlice({
    name: 'proview',
    initialState,
    reducers: {
        setShouldStartProview: (state, _action) => {
            state.shouldStartProview = true;
            state.shouldStopProview = false;
        },
        resetStartProview: (state) => {
            state.shouldStartProview = false;
        },
        setShouldStopProview: (state, _action) => {
            state.shouldStopProview = true;
            state.shouldStartProview = false;
        },
        resetStopProview: (state) => {
            state.shouldStopProview = false;
        },
        proviewSessionInitialized: (state, action) => {
            state.getSessionUUID = action.payload.sessionUUID;
        },
        // Distinct from proviewSessionInitialized: that action's type is also the trigger for
        // proviewSessionInitializedWatcher (saga.ts), which treats ANY dispatch of it as "a real
        // ProView session just finished" and force-sets sessionInitStatus to 'success'. Clearing
        // the stale session_uuid on reattempt via that action would spuriously fire the watcher
        // with an empty UUID (CX-5829 follow-up), so the reset gets its own action instead.
        resetProviewSession: (state) => {
            state.getSessionUUID = '';
            state.sessionInitStatus = 'pending';
        },
        setProviewSessionInitStatus: (state, action) => {
            state.sessionInitStatus = action.payload.status;
        },
        setIsProviewReady: (state, action) => {
            state.isProviewReady = action.payload;
        },
        setIsSessionActive: (state, action) => {
            state.isSessionActive = action.payload;
        },
        setIsProviewV8Failed: (state, action) => {
            state.isProviewV8Failed = action.payload;
        },
    },
});
export const { setShouldStartProview, resetStartProview, setShouldStopProview, resetStopProview, proviewSessionInitialized, resetProviewSession, setProviewSessionInitStatus, setIsProviewReady, setIsSessionActive, setIsProviewV8Failed, } = proviewSlice.actions;
export default proviewSlice.reducer;
